import { z } from 'zod';

// TODO: remove after SRT upload endpoint will be implemented
const ContentSchema = z.object({
  lang: z.string(),
  text: z.string(),
});

const ParsedSegmentSchema = z.object({
  dst: ContentSchema.optional(),
  end: z.string(),
  speaker: z.string().optional(),
  src: ContentSchema.optional(),
  start: z.string(),
});

export const ParsedSrtSchema = z.array(ParsedSegmentSchema).nullable();

export type ParsedSrt = z.infer<typeof ParsedSrtSchema>;
